'use client'

import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconCheckCircle, IconCopy } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useCopyText } from '../../../generic-hooks'

const COPY_TEXT_NOTIFICATION_TIMEOUT = 4000

type StoryblokVoucherCardButtonProps = {
  code: string
}

export const StoryblokVoucherCardButton: FC<
  StoryblokVoucherCardButtonProps
> = ({ code }) => {
  const { copied, copyText } = useCopyText(code, COPY_TEXT_NOTIFICATION_TIMEOUT)

  return (
    <Button
      aria-live="polite"
      className={clsx(
        'mt-auto',
        copied && 'border-transparent hover:border-transparent',
      )}
      color={copied ? 'secondary' : 'primary'}
      endIcon={
        copied ? (
          <IconCheckCircle className="text-dark-success" />
        ) : (
          <IconCopy />
        )
      }
      onClick={(): void => {
        if (copied) {
          return
        }

        void copyText()
      }}
      size="large"
      type="button"
    >
      <span className="flex flex-col">
        <span
          aria-hidden={!copied}
          className={clsx(
            'text-dark-success',
            copied ? null : 'invisible h-0 overflow-hidden',
          )}
        >
          <FormattedMessage id="storyblok.voucher.copied" />
        </span>
        <span
          aria-hidden={copied}
          className={clsx(copied ? 'invisible h-0 overflow-hidden' : null)}
        >
          <FormattedMessage id="storyblok.voucher.copy" />
        </span>
      </span>
    </Button>
  )
}
